import { Link } from "react-router-dom"
import styles from "../../styles/AboutUs.module.css"
import terminalImage from "../../assets/pos.JPG"

const CareersSection = () => {
  return (
    <div
      className={styles.bottom}
      style={{
        backgroundColor: "var(--primary-green)",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: "35px",
        marginBottom: "40px",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "center",
          margin: "0 auto",
        }}
      >
        <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Careers
          </h2>
          <p className={styles.parag}>
            <span className={styles.icon}>✦</span> If you are interested in working at Arifpay, We want to hear from
            you.
          </p>
          <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
            <Link to="/Jobs">
              <button
                className={styles.but}
                style={{
                  backgroundColor: "#fff",
                  color: "green",
                  border: "none",
                  padding: "15px 30px",
                  borderRadius: "5px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Join us Now →
              </button>
            </Link>
          </div>
        </div>
        {/* Image Side */}
        <div
          className={styles.carierImage}
          style={{
            flex: "1",
            display: "flex",
            justifyContent: window.innerWidth < 768 ? "center" : "flex-end",
            marginTop: window.innerWidth < 768 ? "20px" : "0",
          }}
        >
          <img
            src={terminalImage || "/placeholder.svg"}
            alt="Payment Terminal"
            style={{
              width: "100%",
              maxWidth: window.innerWidth < 768 ? "100%" : "450px",
              height: "auto",
              objectFit: "cover",
              borderRadius: "25px",
              border: "5px solid green",
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default CareersSection
